document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('[data-hoov-nav-item]');

  const closeAll = (except) => {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      const caret = item.querySelector('[data-hoov-caret]');
      if (caret) caret.setAttribute('aria-expanded', 'false');
    });
  };

  items.forEach((item) => {
    const caret = item.querySelector('[data-hoov-caret]');
    if (!caret) return;

    caret.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = item.classList.contains('is-open');
      closeAll(item);
      item.classList.toggle('is-open', !isOpen);
      caret.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', (event) => {
    if (![...items].some((item) => item.contains(event.target))) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  document.querySelectorAll('[data-hoov-drawer]').forEach((drawer) => {
    const header = drawer.closest('.hoov-header');
    if (!header) return;

    const openBtn = header.querySelector('[data-hoov-drawer-open]');
    const closeBtn = drawer.querySelector('[data-hoov-drawer-close]');
    const overlay = header.querySelector('[data-hoov-drawer-overlay]');

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hoov-drawer-locked');
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hoov-drawer-locked');
    };

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });

    drawer.querySelectorAll('[data-hoov-drawer-accordion]').forEach((toggle) => {
      const submenu = toggle.parentElement.querySelector('[data-hoov-drawer-submenu]');
      if (!submenu) return;

      toggle.addEventListener('click', () => {
        const isOpen = submenu.classList.contains('is-open');
        submenu.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
});
